module.exports = function (app) {
    'use strict';

    app.directive('eprMedicare', function () {
        return {
            template: require('directives/employee/eprMedicare.html'),
            restrict: 'A',
            replace: false,

            scope: {
                editMode: '=?',
                person: '=eprMedicare',
                validationSuffix: '='
            },
            controller: ['$state', '$scope', 'modal','addFlowCommander', function ($state, $scope, modal, addFlowCommander) {
                $scope.commander = addFlowCommander;
                $scope.isChrome = ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) &&(navigator.vendor.toLowerCase().indexOf("google") > -1));
                $scope.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                $scope.getForm = function () {
                    return $scope["Medicare_" + $scope.validationSuffix];
                };

                $scope.getFormField = function (fieldName) {
                    return $scope.getForm() ? $scope.getForm()[fieldName] : {};
                };

                $scope.medicareClaimNumberValidator = {
                    test: function (value) {
                        var oneAlpha = /[a-zA-Z]/,
                            numAndAlpha = /[A-Za-z0-9]/;
                        var inValid = /\s/g;
                        //console.log("inValid",inValid.test(value))
                        return ((value.length >= 7 && numAndAlpha.test(value) && oneAlpha.test(value) && !inValid.test(value)) || ( value.length >= 7 && oneAlpha.test(value) && !inValid.test(value)));
                    }
                        //Variable Declarations
                    //     var regexpHICBySSA = /[0-9]{9}[A-Za-z][A-Za-z0-9]?/,
                    //     regexpHICByRRBSix = /[A-Za-z0-9]/,
                    //     regexpHICByRRBNine = /[A-Za-z]{1,3}[0-9]{9}/,
                    //     onlyNumbersFromValue = value.replace(/\D/g,''),
                    //     //firstThreeNumbers = "" + onlyNumbersFromValue.charAt(0) + onlyNumbersFromValue.charAt(1) + onlyNumbersFromValue.charAt(2),
                    //     validSSN = "",
                    //     testingForMBI = value.split(""),
                    //     allowableLetters = /[AC-HJKMNPQRT-Y]/,
                    //     allowableNumbers = /[0-9]/,
                    //     allowableNumbersFirstPosition = /[1-9]/,
                    //     allowableLetsAndNums = /[AC-HJKMNPQRT-Y0-9]/;
                    //
                    //     //This checks if the number entered is a valid SSN and accounts for 1 more digit in optional 11th position
                    //     if (onlyNumbersFromValue.length === 9 || onlyNumbersFromValue.length === 10) {
                    //         // //allowable first 3 digits of a social security number are greater than 000 and less than 772 currently
                    //         // if ((parseInt(firstThreeNumbers, 10) > 0) && (parseInt(firstThreeNumbers, 10) <= 772)) {
                    //             //4th and 5th digits can not both be 0
                    //             if (onlyNumbersFromValue.charAt(3) === "0" && onlyNumbersFromValue.charAt(4) === "0") {
                    //                 validSSN = false;
                    //                 //last 4 digits can not all be 0
                    //             }  else if (onlyNumbersFromValue.charAt(5) === "0" && onlyNumbersFromValue.charAt(6) === "0" && onlyNumbersFromValue.charAt(7) === "0" && onlyNumbersFromValue.charAt(8) === "0") {
                    //                 validSSN = false;
                    //             } else {
                    //                 //the first 9 digits are a valid social security number with a possible 10th optional digit
                    //                 validSSN = true;
                    //             }
                    //         // } else {
                    //         //     validSSN = false;
                    //         // }
                    //     } else {
                    //         validSSN = false;
                    //     }
                    //     /*HIC by SSA is a social security number with optional 10th Char as a Letter and optional 11th as letter or number
                    //      HIC by RRB is either 6 or 9 digits with as many as a 3 letter prefix
                    //      if not HIC, check for 11 chars, if so the allowable pattern for MBI is as follows
                    //      string positions 2 5 8 and 9 are uppercase letters excluding SLOIB and Z to avoid confusion
                    //      1 is any number but 0, 4 7 10 11 are numbers and 3 and 6 are numbers or uppercase letters excluding SLOIB and Z.*/
                    //     var isHICBySSA = (validSSN && regexpHICBySSA.test(value)),
                    //         isHICByRRB = (regexpHICByRRBSix.test(value) || regexpHICByRRBNine.test(value)),
                    //         isMBI = allowableLetters.test(testingForMBI[1]) && allowableLetters.test(testingForMBI[4]) &&
                    //             allowableLetters.test(testingForMBI[7]) && allowableLetters.test(testingForMBI[8]) &&
                    //             allowableNumbersFirstPosition.test(testingForMBI[0]) &&
                    //             allowableNumbers.test(testingForMBI[3]) && allowableNumbers.test(testingForMBI[6]) &&
                    //             allowableNumbers.test(testingForMBI[9]) && allowableNumbers.test(testingForMBI[10])&&
                    //             allowableLetsAndNums.test(testingForMBI[2]) && allowableLetsAndNums.test(testingForMBI[5]);
                    //
                    //     return (value.length <= 12 && (isHICBySSA || isHICByRRB)) || (value.length === 11 && isMBI);
                    // }
                };
            }]
        };
    });
};
